/* eslint-disable max-len */
/* eslint-disable @typescript-eslint/naming-convention */
import { Injectable } from '@angular/core';
import { LightGallery } from 'lightgallery/lightgallery';
import _ from 'lodash';

@Injectable({
  providedIn: 'root'
})
export class LightGalleryService {

  lightGallery: LightGallery;
  subHtml: any;
  constructor() { }

  setDownloadUrl(cb: any): void {
    this.subHtml = cb;
  }

  getDownloadUrl(detail: any): void {
    this.subHtml(detail);
  }

}
